import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';


@Injectable()
export class DeactivateGuard  {
  constructor(private shared: SharedService, private location: Location) { }

  canDeactivate(target: any, currentRoute: ActivatedRouteSnapshot, curState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {

    if (target && target.letLeave == true) {
      return true
    }
    const fromNew = curState.url && curState.url.endsWith("new") && !nextState?.url.endsWith("new")
    let checkUrl = true
    if (currentRoute.data.deactivateCheckUrl) {
      const dea = Array.isArray(currentRoute.data.deactivateCheckUrl) ? currentRoute.data.deactivateCheckUrl : [currentRoute.data.deactivateCheckUrl]
      const states = nextState?.url.split("/")
      for (let i = 0; i < dea.length; i++) {
        if (states.includes(dea[i])) {
          checkUrl = false
          break
        }
      }
    }
    if (environment.production && !fromNew && checkUrl)
      return window.confirm(this.shared.t("did_you_saved_prevent"))
    return true
  }

}